import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { getAccount } from '@/api';

/** Layout for `/profile/withdrawals` and `/profile/withdrawals/$providerId`. */
export const Route = createFileRoute('/profile/withdrawals')({
  beforeLoad: () => {
    const account = getAccount();
    if (account?.AllowWithdrawals === false) {
      throw redirect({ to: '/profile' });
    }
  },
  component: ProfileWithdrawalsLayout,
});

function ProfileWithdrawalsLayout() {
  return <Outlet />;
}
